import * as nacl from 'tweetnacl';
import * as naclUtils from 'tweetnacl-util';
import * as _ from 'lodash';

export class EncryptionService {

  constructor() {
  }

  static createKeyPair() {
    let keyPair = nacl.box.keyPair();
    return {
      privateKey: keyPair.secretKey,
      publicKey: keyPair.publicKey
    };
  }

  static createKeyPairBase64() {
    let keyPair = this.createKeyPair();
    return {
      privateKey: this.encodeBase64(keyPair.privateKey),
      publicKey: this.encodeBase64(keyPair.publicKey)
    };
  }

  static createRandomBytesBase64(amount: number) {
    const randomBytes = nacl.randomBytes(amount);
    return this.encodeBase64(randomBytes);
  }

  static openBox(message: Uint8Array | string, publicKey: Uint8Array | string, privateKey: Uint8Array | string) {
    if (_.isString(publicKey)) {
      publicKey = this.decodeBase64(<string>publicKey);
    }
    if (_.isString(privateKey)) {
      privateKey = this.decodeBase64(<string>privateKey);
    }
    if (_.isString(message)) {
      message = this.decodeBase64(<string>message);
    }

    const nonce = (<Uint8Array>message).subarray(0, 24);
    const encrypted = (<Uint8Array>message).subarray(24);

    return this.encodeUTF8(nacl.box.open(encrypted, nonce, publicKey, privateKey));
  }

  static cryptBox(value: Uint8Array | string, publicKey: Uint8Array | string, privateKey: Uint8Array | string) {
    if (_.isString(value)) {
      value = this.decodeUTF8(<string>value);
    }
    if (_.isString(publicKey)) {
      publicKey = this.decodeBase64(<string>publicKey);
    }
    if (_.isString(privateKey)) {
      privateKey = this.decodeBase64(<string>privateKey);
    }
    const nonce = this.createNonce();

    return this.encodeBase64(this.mergeTypedArrays(nonce, nacl.box(value, nonce, publicKey, privateKey)));
  }

  static hash(value: Uint8Array | string) {
    if (_.isString(value)) {
      value = this.decodeUTF8('ibex ultra safe salt' + <string>value);
    } else {
      value = this.mergeTypedArrays(this.decodeUTF8('ibex ultra safe salt'), value);
    }

    return this.encodeBase64(nacl.hash(value));
  }

  static createNonce() {
    return nacl.randomBytes(24);
  }

  static encodeUTF8(value: Uint8Array): string {
    if (!value) {
      return null;
    }
    return naclUtils.encodeUTF8(value);
  }

  static decodeUTF8(value: string): Uint8Array {
    return naclUtils.decodeUTF8(value);
  }

  static encodeBase64(value: Uint8Array): string {
    if (!value) {
      return null;
    }
    return naclUtils.encodeBase64(value);
  }

  static decodeBase64(value: string): Uint8Array {
    return naclUtils.decodeBase64(value);
  }

  static mergeTypedArrays(a, b): Uint8Array {
    // Checks for truthy values on both arrays
    if (!a && !b) {
      throw 'Please specify valid arguments for parameters a and b.';
    }

    // Checks for truthy values or empty arrays on each argument
    // to avoid the unnecessary construction of a new array and
    // the type comparison
    if (!b || b.length === 0) {
      return a;
    }
    if (!a || a.length === 0) {
      return b;
    }

    // Make sure that both typed arrays are of the same type
    if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b)) {
      throw 'The types of the two arguments passed for parameters a and b do not match.';
    }

    var c = new a.constructor(a.length + b.length);
    c.set(a);
    c.set(b, a.length);

    return c;
  }
}
